<main class="panel" fxFlex>
  <p class="panel-heading is-pink">
    {{ title }}
  </p>

  <div class="content">

    <ng-container *ngIf="orders == null">
      <div class="loader"></div>
    </ng-container>


    <div *ngIf="orders !== null && orders.length === 0; else content" class="order-item p-3">
      Brak zamówień
    </div>

    <ng-template #content>

      <table class="table">
        <tbody>
        <tr *ngFor="let order of orders; let i=index">
          <ng-container *ngIf="(limit !== undefined && limit > i) || limit === undefined">
            <td><strong class="has-text-weight-medium">{{ order?.RestaurantName }}</strong></td>
            <td><p>{{ order!!.Created * 1000 | date:'y-MM-dd HH:mm:ss' }}</p></td>
            <td><p class="status has-text-success has-text-weight-medium">{{ Status.getStatusName(order.Status) }}</p></td>
            <td><p>{{ (order.TotalV2 / 100) | number: '1.2-2' }} zł</p></td>
            <td><a  href="account/orders/{{ order?.Id }}" class="pr-3 pl-3"><i class="fas fa-circle-info" style="color: #d9107b"></i></a></td>
          </ng-container>
        </tr>
        </tbody>
      </table>
    </ng-template>

  </div>


</main>
